import {useEffect} from "react";
import "@/App.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/HomePage";
import {Toaster} from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import Lenis from "lenis";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
      <ErrorBoundary>
        <div className="App min-h-screen bg-background">
          <div className="noise-overlay"/>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage/>}/>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right"/>
        </div>
      </ErrorBoundary>
  );
}

export default App;
